import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MapService } from '../../map/service/map.service';
import { CoordinatesDTO } from 'src/app/shared/dto/common.dto';
import { MapOptionsConstants, UserIconPositionConst } from 'src/app/shared/constants/common.constants';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { CountryCmbDto } from 'src/app/shared/dto/country.dto';
import { CityDto, StateDto } from 'src/app/shared/dto/city.dto';
import { serviceCenterCategoryDTO } from 'src/app/shared/dto/service-center-category.dto';
import { serviceCenterCategoryServiceDTO } from 'src/app/shared/dto/service-center-category-services.dto';
import { serviceDTO } from 'src/app/shared/dto/serrvice.dto';
import { ActivatedRoute } from '@angular/router';
import { ServiceCenterService } from './service-center.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
@Component({
  selector: 'app-workshop-form',
  templateUrl: './service-center-form.component.html',
  styleUrls: ['./service-center-form.component.css'],
})
export class ServiceCenterFormComponent implements OnInit {
  registroForm: FormGroup;
  coords: CoordinatesDTO = { lat: 0, lng: 0 };
  userIconPosition = UserIconPositionConst;
  mapOptions = MapOptionsConstants;

  countries: CountryCmbDto[] = [];
  states: StateDto[] = [];
  cities: CityDto[] = [];
  images: string[] = [];

  listVehicleTypesAll: any[] = [];
  serviceCenterCategories: any[] = [];
  serviceCenterCategoryServicesByCategory: any[] = [];
  services: any[] = [];
  listCategorySelected: any[] = [];
  servicesSelected: any[] = [];
  imageBase641: string = '';
  imageBase642: string = '';
  imageBase643: string = '';
  imageBase644: string = '';
  imageBase645: string = '';
  imageBase646: string = '';
  imageBase647: string = '';
  imageBase648: string = '';

  tag = '';

  constructor(
    private fb: FormBuilder,
    public mapService: MapService,
    private readonly commonService: CommonService,
    private readonly route: ActivatedRoute,
    private readonly serviceCenterService: ServiceCenterService,
    private router: Router,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.tag = params['tag'];
    });

    this.registroForm = this.fb.group({
      contry: ['CO', Validators.required],
      departament: ['', Validators.required],
      cities: ['', Validators.required],
      workshopName: ['', Validators.required],
      names: ['', Validators.required],
      lastnames: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      latitud: [''],
      longitud: [''],
      selectVehicleType: '',
      selectCategory: '',
      selectServiceCategory: '',
      selectService: [''],
      terms: [false, Validators.requiredTrue],
      images: this.fb.array([]),
      tag: this.tag,
    });
  }

  ngOnInit() {
    this.getAvailableCountriesToCmb();
    this.getlistVehicleTypesAll();
  }

  async getAvailableCountriesToCmb() {
    this.countries = await this.commonService.getAvailableCountriesToCmb();
    this.onPaisChange();
  }

  async getlistVehicleTypesAll() {
    const result = (await this.commonService.getlistVehicleTypesAll()).map((option: any) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });

    this.listVehicleTypesAll = result;
  }

  async getAvailableCityByStateCountryCode() {
    this.cities = [];
    const result = await this.commonService.getAvailableCityByStateCountryCode(
      this.registroForm.get('contry')?.value,
      this.registroForm.get('departament')?.value,
    );
    this.cities = result;
  }

  obtenerUbicacion() {
    this.coords = { lat: 0, lng: 0 };
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.registroForm.patchValue({
            latitud: position.coords.latitude,
            longitud: position.coords.longitude,
          });
          this.coords = { lat: position.coords.latitude, lng: position.coords.longitude };
        },
        (error) => {
          console.error('Error al obtener ubicación', error);
        },
      );
    } else {
      //   console.error('Geolocalización no soportada en este navegador.');
    }
  }

  async onPaisChange() {
    this.states = await this.commonService.getAvailableStatesByCountryCode(this.registroForm.get('contry')?.value);
  }

  onDepartamentoChange() {
    this.registroForm.patchValue({ ciudad: '' });
  }

  async onSelectVehicleTypeChange() {
    const selectVehicleType = this.registroForm
      .get('selectVehicleType')
      ?.value.map((option: any) => option._id)
      .join(',');
    const result = (await this.commonService.getAvailableServiceCenterCategories(selectVehicleType)).map((option: serviceCenterCategoryDTO) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });

    this.serviceCenterCategories = result;
  }

  async onSelectCategoryChange() {
    this.registroForm.get('selectServiceCategory')?.reset();
    this.registroForm.get('selectService')?.reset();
    const result = (await this.commonService.getAvailableServiceCenterCategoryServicesByCategoryId(this.registroForm.get('selectCategory')?.value)).map(
      (option: serviceCenterCategoryServiceDTO) => {
        return {
          _id: option._id,
          name: option.name.es,
        };
      },
    );

    this.serviceCenterCategoryServicesByCategory = result;
  }

  async onSelectServiceCategoryChange() {
    this.registroForm.get('selectService')?.reset();
    const result = (
      await this.commonService.getAvailableServiceCenterCategoryServicesSubServicesByServiceId(this.registroForm.get('selectServiceCategory')?.value)
    ).map((option: serviceDTO) => {
      return {
        _id: option._id,
        name: option.name.es,
      };
    });
    this.services = result;
  }

  addService() {
    const subServices = this.registroForm.get('selectService')?.value;
    if (subServices && subServices.length) {
      const services = {
        categoryId: this.registroForm.get('selectCategory')?.value,
        serviceId: this.registroForm.get('selectServiceCategory')?.value,
        subServiceIds: this.registroForm.get('selectService')?.value.map((item: any) => item._id),
        vehicleTypes: this.registroForm.get('selectVehicleType')?.value.map((item: any) => item._id),
      };
      this.servicesSelected.push(services);
      const findCategory: any = this.serviceCenterCategoryServicesByCategory.find((item) => item._id === services.serviceId);
      if (findCategory) this.listCategorySelected.push(findCategory);
      this.cleanForm();
    } else {
      alert('Selecciona subs ervicios');
    }
  }

  removeService(idx: number) {
    this.listCategorySelected.splice(idx, 1);
    this.servicesSelected.splice(idx, 1);
  }

  cleanForm() {
    this.registroForm.get('selectService')?.reset();
  }
  toggleRegister() {
    this.router.navigate(['/register-main']);
  }

  onFileSelected(event: any, img: number): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imgB64 = e.target.result;
        switch (img) {
          case 1:
            this.imageBase641 = imgB64;
            break;
          case 2:
            this.imageBase642 = imgB64;
            break;
          case 3:
            this.imageBase643 = imgB64;
            break;
          case 4:
            this.imageBase644 = imgB64;
            break;
          case 5:
            this.imageBase645 = imgB64;
            break;
          case 6:
            this.imageBase646 = imgB64;
            break;
          case 7:
            this.imageBase647 = imgB64;
            break;
          case 8:
            this.imageBase648 = imgB64;
            break;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  onSubmit() {
    if (this.registroForm.valid) {
      const country = this.countries.find((cty) => cty.cca2 === this.registroForm.get('contry')?.value);
      const state = this.states.find((ste) => ste.state_code === this.registroForm.get('departament')?.value);
      const city = this.cities.find((cty) => cty.city_code === this.registroForm.get('cities')?.value);
      const dt = {
        companyName: this.registroForm.get('workshopName')?.value,
        dni: '',
        name: this.registroForm.get('names')?.value,
        lastName: this.registroForm.get('lastnames')?.value,
        typeDocument: '',
        documentNumber: '',
        mobileObject: {
          code: country?.CODIGO_TEL_PAIS ?? '+57',
          number: this.registroForm.get('phone')?.value,
        },
        gpsLocation: {
          type: 'Point',
          coordinates: [Number(this.registroForm.get('longitud')?.value), Number(this.registroForm.get('latitud')?.value)],
        },
        services: [...this.servicesSelected],
        country: country?.name.nativeName.es.common,
        countryCode: country?.cca2,
        address: '',
        state: state?.state_name,
        stateCode: state?.state_code,
        city: city?.city_name,
        cityCode: city?.city_code,
        email: this.registroForm.get('email')?.value,
        password: '*******',
        image1: this.imageBase641,
        image2: this.imageBase642,
        image3: this.imageBase643,
        image4: this.imageBase644,
        image5: this.imageBase645,
        image6: this.imageBase646,
        image7: this.imageBase647,
        image8: this.imageBase648,
        tagAccountOrigin: this.tag,
      };
      //   console.log('dt', dt);
      this.create(dt);
    } else {
      //   console.error('El formulario tiene errores');
    }
  }

  async create(dt: any) {
    try {
      const rsp = await this.serviceCenterService.createServiceCenter(dt);
      console.log(rsp);
      if (rsp.code.code === 'PTZ0000') {
        Swal.fire({
          toast: true,
          icon: 'success',
          title: 'Perfil actualizado',
          text: 'Se ha registrado correctamente.',
          showConfirmButton: true,
        });
        this.registroForm.reset();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Error en registro',
          text: `${rsp.code.message.es} | ${rsp.error}`,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error('ServiceCEnter | create | error', error);
      Swal.fire({
        toast: true,
        icon: 'error',
        title: 'Error en registro',
        text: 'No se h alogrado procesar la informacion.',
        showConfirmButton: true,
      });
    }
  }
}
